import { NavigationMenuItem } from '@app/containers/models/navigation-menu-item';

export const NAVIGATION_MENU_ITEMS: NavigationMenuItem[] = [
  { link: 'clients', label: 'Clients', icon: 'package-variant' },
  { link: 'system-admins', label: 'Admins', icon: 'shield-account' },
  { link: 'sso', label: 'SSO', icon: 'shield-key' }
];
